module.exports = __webpack_public_path__ + "assets/img/customer-3.edbdc2be.png";